import { useFormik } from 'formik';
import PropTypes from 'prop-types';
//import material
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
//import style
import { DialogTitle, DialogContent, DialogActions, ProductomodalContainer } from './productosComponents';
import { validationSchema } from './validation';
import { styles } from './productosComponents';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import { NativeSelect } from '@mui/material';
import { useContext, useState } from 'react';
import { AdminContext } from '../../context/AdminContext';
import { SNACKBAR_SEVERITY } from '../../constants';
import { ProductContext } from '../../context/ProductContext';
import CircleLoader from 'react-spinners/CircleLoader'
function ModalCambiarPrecio({ modal, toggleModal, selectedRows, clearSelection }) {
  const classes = styles;

  const { handleClickSnackbar } = useContext(AdminContext);
  const { PrecioEnMasa } = useContext(ProductContext);
  const [loading, setLoading] = useState(false);
  const initialValues = { opType: 'aumentar', porcentaje: 0 };

  const formik = useFormik({
    initialValues,
    validationSchema: validationSchema,

    onSubmit: async values => {
      const ids = selectedRows.map(row => {
        return row._id;
      });
      setLoading(true);
      const exito = await PrecioEnMasa(ids, values.opType, values.porcentaje);
      if (exito) handleClickSnackbar('Precios actualizados exitosamente', SNACKBAR_SEVERITY.success);
      else handleClickSnackbar('No se logró cambiar los precios', SNACKBAR_SEVERITY.error);
      handleClose();
    },
    enableReinitialize: true,
  });

  function handleClose() {
    formik.resetForm();
    setLoading(false);
    clearSelection();
    toggleModal();
  }

  return (
    <div>
      <Dialog onClose={handleClose} aria-labelledby='customized-dialog-title' open={modal} maxWidth='lg'>
        <CircleLoader loading={loading} cssOverride={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }} />
        <form onSubmit={formik.handleSubmit} style={{ opacity: loading ? 0 : 100 }} className={classes.form}>
          <DialogTitle id='customized-dialog-title' onClose={handleClose}>
            Cambiar Precio
          </DialogTitle>

          <DialogContent dividers>
            <ProductomodalContainer>
              <TextField
                variant="standard"
                fullWidth
                id='porcentaje'
                name='porcentaje'
                label='Escriba el valor en porcentaje'
                value={formik.values.porcentaje}
                error={formik.errors.porcentaje}
                helperText={formik.errors.porcentaje}
                onChange={formik.handleChange} />
              <FormControl variant="standard" className={classes.formControl}>
                <InputLabel htmlFor='opType'>Elegir una opcion</InputLabel>
                <NativeSelect
                  value={formik.values.opType}
                  onChange={formik.handleChange}
                  inputProps={{
                    name: 'opType',
                    id: 'opType',
                  }}
                  error={formik.touched.opType && Boolean(formik.errors.opType)}>
                  <option value={'aumentar'}>AUMENTAR</option>
                  <option value={'disminuir'}>DISMINUIR</option>
                </NativeSelect>
              </FormControl>
            </ProductomodalContainer>
          </DialogContent>
          <DialogActions>
            <Button color='primary' variant='contained' type='submit' >
              Aceptar
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </div>
  );
}

ModalCambiarPrecio.propTypes = {
  modal: PropTypes.bool.isRequired,
  toggleModal: PropTypes.func.isRequired,
  selectedRows: PropTypes.array,
  clearSelection: PropTypes.func,
};

export default ModalCambiarPrecio;
